<div id="preloader" *ngIf="loading">
    <div id="status" >
        <img src="../../../../assets/loader/loaderBox.gif">
        <!-- <div class="spinner-chase">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
        </div> -->
    
    </div>
</div>